import { FC } from "react";
import { Input } from "../../TrueUI";
import { AgencyPoliciesTotalPremiumProps } from "./TypesAgencyPolicies";
import { useGetTableDataForFilter } from "../../../hooks/useGetTableDataForFilter";
import { getIndexOfColumn } from "../../TrueUI/Tables/tableFunctions";

const AgencyPoliciesTotalPremium: FC<AgencyPoliciesTotalPremiumProps> = ({
  tableName,
}) => {
  const { useTableDataFromInstance } = useGetTableDataForFilter();

  const columns = useTableDataFromInstance(
    tableName,
    "columns",
    "AgencyPoliciesTotalPremium"
  );
  const data = useTableDataFromInstance(
    tableName,
    "data",
    "AgencyPoliciesTotalPremium"
  );
  const totalPremiumIndex = getIndexOfColumn(columns ?? [], "TotalPremium");
  const totalPremium = data?.[0]?.[totalPremiumIndex] ?? 0;

  return (
    <Input
      id={"agency_policies_total_premium"}
      name={"agency_policies_total_premium"}
      label={"Total Premium"}
      readOnly
      value={totalPremium}
      labelPosition={"start"}
      labelFontType={"TITLE"}
    />
  );
};
export default AgencyPoliciesTotalPremium;
